import { createApp, h, inject } from 'vue'
import ConfirmTemplate from '@/plugins/confirm/ConfirmTemplate.vue'

export default {
  install(app, options) {
    let confirmInstance = null
    let confirmApp = null
    let container = null

    const cleanup = () => {
      setTimeout(() => {
        if (confirmApp) {
          confirmApp.unmount()
          confirmApp = null
        }
        if (container && container.parentNode) {
          container.parentNode.removeChild(container)
        }
        container = null
        confirmInstance = null
      }, 300)
    }

    app.config.globalProperties.$confirm = (config) => {
      return new Promise((resolve, reject) => {
        if (confirmInstance) {
          reject(new Error('Uma confirmação já está em andamento'))
          return
        }

        // Criar container para o componente
        container = document.createElement('div')
        document.body.appendChild(container)

        // Criar aplicação Vue 3 com o componente usando h() para passar props e listeners
        confirmApp = createApp({
          setup() {
            return () =>
              h(ConfirmTemplate, {
                ref: (el) => {
                  if (el && !confirmInstance) {
                    confirmInstance = el
                    el.open = true
                  }
                },
                title: config?.title || '',
                message: config?.message || '',
                confirmText: config?.confirmText || 'Sim',
                cancelText: config?.cancelText || 'Não',
                confirmColor: config?.confirmColor || 'marca-0-l10',
                cancelColor: config?.cancelColor || undefined,
                hideCancel: config?.hideCancel || false,
                onConfirm: () => {
                  if (confirmInstance) {
                    confirmInstance.open = false
                  }
                  cleanup()
                  resolve()
                },
                onCancel: () => {
                  if (confirmInstance) {
                    confirmInstance.open = false
                  }
                  cleanup()
                  reject('')
                },
              })
          },
        })

        // Usar os plugins globais da aplicação principal
        if (options?.vuetify) {
          confirmApp.use(options.vuetify)
        }
        if (options?.router) {
          confirmApp.use(options.router)
        }
        if (options?.pinia) {
          confirmApp.use(options.pinia)
        }
        if (options?.safeHTMLPlugin) {
          confirmApp.use(options.safeHTMLPlugin)
        }

        // Montar a aplicação
        confirmApp.mount(container)
      })
    }
    app.config.globalProperties.__confirmCleanup = cleanup
    app.provide('$confirm', app.config.globalProperties.$confirm)
  },
}

export function useConfirm() {
  const $confirm = inject('$confirm')
  if (!$confirm) {
    throw new Error('Plugin confirm not found')
  }
  return $confirm
}
